
import PIXI from '../GameEngine/pixi.js';
export default class PlayerScoreBoard extends PIXI.Sprite {
    constructor(name, avatar, color, rank) {
        super();
        this.score = 0;
        this.name = name || "Player";
        this.avatar = avatar;// || "Avatar";
        this.color = color || 0x479ACE;// or 0x479ACE or 0xC03500
        this.rank = rank || "";

        var styleName = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 26,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });

        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 46,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });

        var background = new PIXI.Graphics();
        background.beginFill(0x000000);
        //background.lineStyle(2, 0xFFFF00, 1);
        background.drawRect(0, 0, 100, 100);
        //background.drawRoundedRect(0, 0, 200, 100, 10);
        //background.alpha = 0.8;
        this.addChild(background);

        var backgroundAvatar = new PIXI.Graphics();
        backgroundAvatar.beginFill(this.color);
        //backgroundAvatar.beginFill(0x555555);

        //backgroundAvatar.beginFill(0x999999);
        //backgroundAvatar.beginFill(0xFFFFFF);
        //backgroundAvatar.beginFill(0x000000);
        //background.lineStyle(0, 0xFFFFFF, 1);
        backgroundAvatar.drawRect(0, 0, 100, 100);
        //graphics.drawRoundedRect(0, 0, 200, 100, 10);
        // background.alpha = 0.5;
        this.addChild(backgroundAvatar);


        //Avatar 
        //this.Avatar = new PIXI.Sprite(PIXI.Loader.shared.resources[this.avatar].texture);
        this.Avatar = new PIXI.Sprite();
        this.Avatar.x = 0;
        this.Avatar.y = 0;
        this.Avatar.width = 100;
        this.Avatar.height = 100;
        this.addChild(this.Avatar);

        //Rank 
        this.Rank = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.Rank.x = 0;
        this.Rank.y = 0;
        this.Rank.width = 30;
        this.Rank.height = 30;
        this.addChild(this.Rank);


        //score box
        var scoreBox = new PIXI.Graphics();
        scoreBox.beginFill(this.color);
        // scoreBox.drawRect(0,115, 100, 25);
        scoreBox.drawRoundedRect(0, 115 - 10, 100, 25 + 10, 10);
        //scoreBox.alpha = 0.5;
        this.addChild(scoreBox);

        //textPlayer2Points
        this.textPoints = new PIXI.Text('', style);
        this.textPoints.x = 50;
        this.textPoints.y = 115;
        this.textPoints.scale.set(0.5);
        this.textPoints.anchor.set(0.5, 0);
        this.addChild(this.textPoints);



        //Name Box
        var scoreBox = new PIXI.Graphics();
        scoreBox.beginFill(0x000000);
        scoreBox.drawRect(0, 100, 100, 15);
        //scoreBox.alpha = 0.5;
        this.addChild(scoreBox);


        //textName
        this.textName = new PIXI.Text(this.name, styleName);
        this.textName.x = 50;
        this.textName.y = 99;
        this.textName.scale.set(0.5);
        this.textName.anchor.set(0.5, 0);
        this.addChild(this.textName);
    }
    updateLayout() {
        let isDirty = false;
        //should not be updating profile pic texture every frame 
        //todo: check for change and update if needed and set dirty

        this.textName.text = this.name;

        //update rank
        if (this.rank) {
            let badgeName = "Badge" + this.rank + ".png";
            let texture = PIXI.Texture.from(badgeName);
            if (texture)
                this.Rank.texture = texture;
            else
                this.Rank.texture = PIXI.Texture.EMPTY;
        } else {
            this.Rank.texture = PIXI.Texture.EMPTY;
        }


        //update avatar
        //if (!this.avatar)
        //    this.avatar = "Avatar";
        if(!this.avatar){
            this.Avatar.texture = null;
        }
        if (this.avatar) {
            if (this.avatar.indexOf("http") !== -1) {
                let texture = PIXI.Texture.from(this.avatar);
                if (texture)
                    this.Avatar.texture = texture;
            }
            else if (this.avatar.indexOf("assets/") !== -1) {
                let texture = PIXI.Texture.from(this.avatar);
                if (texture)
                    this.Avatar.texture = texture;
            }
            else {
                let resource = PIXI.Loader.shared.resources[this.avatar];
                if (resource && resource.texture)
                    this.Avatar.texture = resource.texture;
            }
        }
        this.textPoints.text = this.score || 0;

        return isDirty;
    }
    updateScore(score) {
        if (score) this.score = score;
        this.textPoints.text = score || 0;
    }

}